export default __webpack_public_path__ + "static/media/ic_car1.0fa1774a.svg";